import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { TristateComponent } from './tristate.dropdown.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [TristateComponent],
    imports: [BrowserModule, FormsModule],
    exports: [TristateComponent]
})

export class TristateModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/tristatedropdown/tristate.module.ts